import { getFormatData, getUrlCanonical, hasAgrupadoraEvaMain, hasSX3Canal, getPageTitle } from '@portal-internet/core';
import { getImatge } from 'components/corporatiu/Imatge';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { removeHtmlTags } from '@portal-internet/core';

const _getNoIndex = (unavailableAfter, estat) => {
    const now = new Date();
    unavailableAfter = unavailableAfter ? unavailableAfter < now : false;
    estat = estat ? estat === 'DESP' : false;
    return unavailableAfter || estat;
};

const _getUrlCanonical = (props, router) => {
    const { nombonic, routePath } = props;
    let url;

    if (routePath) {
        const { id } = router.query;
        url = getUrlCanonical({ slug: nombonic, id, routePath });
    } else {
        url = router.asPath;
        const indexParams = url.indexOf('?');
        url = indexParams > 0 ? url.substring(0, indexParams) : url;
    }

    return 'https://www.3cat.cat' + url;
};

const _getLocale = (lang) => {
    const localeMap = {
        ca: 'ca_ES',
        es: 'es_ES',
        fr: 'fr_ES',
        en: 'en_ES'
    };
    return localeMap[lang] || 'ca_ES';
};

const Metadades = (props) => {
    const {
        imatges,
        sufix,
        prefix,
        separador = ' - ',
        estat,
        desindexar,
        dataCaducitat,
        logicaFaldo,
        canal,
        agrupacions,
        titol = 'Totes les sèries, programes i pel·lícules de TV3 i CatRàdio',
        descripcio = 'Entra al servei online 3cat per veure les sèries, programes i pel·lícules de TV3 i Catalunya Ràdio, a la carta i en directe. Amb contingut exclusiu.',
        tipus = 'website',
        imagePreview = false,
        imatgeDefault
    } = props;

    const textDescripcio = removeHtmlTags(props.descripcioPromo || descripcio);
    const router = useRouter();
    const urlCanonical = _getUrlCanonical(props, router);

    const getImatgeXXSS = () => {
        let img = getImatge(imatges, 'web_xxss', null, null, !!logicaFaldo)?.src;

        if (img) {
            if (logicaFaldo === 'video') {
                const faldo = hasSX3Canal(canal) ? 'sx3' : hasAgrupadoraEvaMain(agrupacions) ? 'eva' : '3cat';
                img = img + '?strip=' + faldo + '-1200x628';
            } else if (logicaFaldo === 'audio' || logicaFaldo === 'noticia') {
                img = img + '?strip=3cat-1200x628';
            }
        } else {
            img = imatgeDefault;
        }
        return img;
    };

    const imgxxss = getImatgeXXSS();
    const titolComplet = getPageTitle(prefix, titol, sufix, separador);
    const unavailableAfter = dataCaducitat ? getFormatData(dataCaducitat) : false;
    const noIndex = _getNoIndex(unavailableAfter, estat) || desindexar;
    const canonicalUrl =
        urlCanonical === 'https://www.3cat.cat/3cat/' || urlCanonical === 'https://www.ccma.cat/3cat/'
            ? 'https://www.3cat.cat/'
            : urlCanonical;

    // ✅ Obtenir locale segons paràmetre lang
    const locale = _getLocale(router.query.lang);

    return (
        <Head>
            <title>{titolComplet}</title>
            <meta name='description' content={textDescripcio} />
            <meta name='author' content='CCMA' />
            {/**Facebook*/}
            <meta property='og:type' content={tipus} />
            <meta property='og:locale' content={locale} />
            <meta property='og:site_name' content='3Cat' />
            <meta property='og:title' content={titolComplet} />
            <meta property='og:description' content={textDescripcio} />
            {imgxxss && <meta property='og:image' content={imgxxss}></meta>}
            <meta property='og:url' content={urlCanonical} />
            {/**Twitter*/}
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={titolComplet} />
            <meta name='twitter:description' content={textDescripcio} />
            <meta name='twitter:site' content='@som3cat'></meta>
            {imgxxss && <meta name='twitter:image' content={imgxxss}></meta>}
            {imgxxss && <meta name='twitter:image:src' content={imgxxss}></meta>}
            <meta name='twitter:url' content={urlCanonical} />
            {/*Canonical*/}
            {urlCanonical && <link rel='canonical' href={canonicalUrl} />}
            {imagePreview && <meta name='robots' content='max-image-preview:large'></meta>}
            {noIndex && <meta name='robots' content='noindex'></meta>}
            {unavailableAfter && <meta name='googlebot' content={'unavailable_after: ' + unavailableAfter}></meta>}
        </Head>
    );
};

export default Metadades;
